export function headerFunc() {
  /**
   * ハンバーガーメニュー
   */
  $('.hamburger').on('click', function() {
    $('.hamburger').toggleClass('close-nav');
    $('.flex-nav-list').toggleClass('open-nav');
  });

  $('.flex-nav-list__item a').on('click', function() {
    $('.hamburger').removeClass('close-nav');
    $('.flex-nav-list').removeClass('open-nav');
  });

  /**
   * ページ内アンカーリンク位置調整
   */
  $('a').on('click', function() {
    let headerHeight = 0;
    if ($(window).width() < 768){
      // スマホならヘッダー分高さをずらす
      headerHeight = $('.header').outerHeight();
    }
    let href = $(this).attr('href');

    if(href.indexOf('#') != -1){
      let anchor = href.split("#");
      let target = $('#' + anchor[anchor.length - 1]);
      let position = Math.floor(target.offset().top) - headerHeight;
      $("html, body").animate({scrollTop:position}, 550, "swing");
      return false;
    }
  });

  /**
   * ページ外アンカーリンク位置調整
   */
   let headerHeight = 0;
   if ($(window).width() < 768){
     // スマホならヘッダー分高さをずらす
     headerHeight = $('.header').outerHeight();
   }
  let href = $(location).attr('href');

  if(href.indexOf("#") != -1){
    let anchor = href.split("#");
    let target = $('#' + anchor[anchor.length - 1]);
    let position = Math.floor(target.offset().top) - headerHeight;
    $("html, body").animate({scrollTop:position}, 500);
  }
}
